export const state = {
  manageOrganizations: [],
  manageOrganization: {}
};

export const getters = {
  getManageOrganizationInfo: state => state.manageOrganization,
  getOrganizations: state => state.manageOrganizations,
  cityById: (state, { getCities }) => id =>
    getCities.find(item => item.id.toString() === id.toString()),
  streetById: (state, { getStreets }) => id =>
    getStreets.find(item => item.id.toString() === id.toString()),
  apartmentById: (state, { getApartments }) => id =>
    getApartments.find(item => item.id.toString() === id.toString()),
  manageOrganizationById: (state, { getOrganizations }) => id =>
    getOrganizations.find(item => item.id.toString() === id.toString())
};

export default {
  state,
  getters
};
